import { trackError } from '../tracking/errorTracker';
import { fetchApi } from '../api/fetchApi';
const importMapURL = '/import-map.json';
let importMapPromise = null;
/**
 *
 * @returns Get a list of the module identifiers available in the import map
 */
export const getImports = () => {
    if (!importMapPromise) {
        importMapPromise = fetchApi(importMapURL)
            .then(response => {
            if (!response.ok) {
                throw new Error(`Failed to fetch import map`);
            }
            return response.json();
        })
            .then(importMap => (importMap === null || importMap === void 0 ? void 0 : importMap.imports) || {})
            .catch(e => {
            trackError(e);
            return {};
        });
    }
    return importMapPromise;
};
/**
 * Get the module for the given identifier
 */
export const getModule = (identifier) => System.import(identifier);
const mountedCSS = {};
/**
 * If there is any CSS associated with a module, load it
 */
export const loadModuleCSS = async (identifier) => {
    const cssURL = System.resolve(`${identifier}-css`);
    if (!cssURL) {
        return;
    }
    return new Promise((resolve, reject) => {
        if (mountedCSS[identifier]) {
            mountedCSS[identifier].count++;
            return resolve();
        }
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = cssURL;
        link.onload = () => resolve();
        link.onerror = reject;
        mountedCSS[identifier] = { count: 1, element: link };
        document.head.appendChild(link);
    });
};
/**
 * Unload the CSS associated with a module
 */
export const unloadModuleCSS = (identifier) => {
    if (!mountedCSS[identifier] || mountedCSS[identifier].count < 1) {
        return;
    }
    mountedCSS[identifier].count--;
    if (mountedCSS[identifier].count === 0) {
        document.head.removeChild(mountedCSS[identifier].element);
        delete mountedCSS[identifier];
    }
};
